enum TabNames {
  Fields = 'Fields',
  Paths = 'Paths'
}

export default TabNames;
